import { FunctionComponent, ReactNode } from 'react';
import { Dialog } from '@material-ui/core';
import { BoxV2 as Box, Flex, SxProps } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  showCloseButton?: boolean; // displays an X button in the top right corner
  sx?: SxProps;
}

const Modal: FunctionComponent<ModalProps> = ({
  open,
  onClose,
  children,
  sx,
  showCloseButton = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: {
          background: 'rgba(73, 83, 93, 0.5)',
          backdropFilter: 'blur(7.5px)',
        },
      }}
      PaperProps={{
        style: {
          width: '525px', // Standard width for profile modals
          padding: '24px 32px 8px',
          borderRadius: '8px',
          maxWidth: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 24,
        },
      }}
    >
      <Box sx={{ width: '100%', ...sx }}>
        {/* Close Button */}
        {showCloseButton && (
          <Flex
            sx={{
              width: 24,
              height: 24,
              fontSize: '22px',
              alignSelf: 'flex-end',
              cursor: 'pointer',
              mb: 2,
              position: 'absolute',
              top: 16,
              right: 16,
            }}
            onClick={onClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </Flex>
        )}

        {/* Content will be injected here */}
        {children}
      </Box>
    </Dialog>
  );
};

export default Modal;
